// extracted by mini-css-extract-plugin
export var dropdown = "_rl-0";
export var imageWrapper = "_rl-3";
export var itemNameContainer = "_rl-1";
export var productImage = "_rl-2";
export var spinnerWrapper = "_rl-4";